import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
export var useDebounce = function useDebounce() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    debounceValue = _useState2[0],
    setDebounceValue = _useState2[1];
  var changeHandler = function changeHandler(value) {
    return setDebounceValue(value);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  var debouncedChangeHandler = useCallback(function (value) {
    var timeoutId;
    return function (event) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        changeHandler(event.target.value);
      }, delay);
    };
  }, [delay]);
  var handleChange = function handleChange(event) {
    debouncedChangeHandler(event.target.value)(event);
  };
  var handleStringChange = function handleStringChange(event) {
    debouncedChangeHandler(event)({
      target: {
        value: event
      }
    });
  };
  return {
    debounceValue: debounceValue,
    handleChange: handleChange,
    handleStringChange: handleStringChange
  };
};